import { funnelReportSchema, type FunnelQuery, type FunnelReport } from '@ai-sales/shared'
import { apiRequest } from '../lib/api-client.js'

export async function fetchFunnel(
  workspaceId: string,
  query: Partial<FunnelQuery>,
): Promise<FunnelReport> {
  const search = new URLSearchParams()

  if (query.groupBy) search.set('groupBy', query.groupBy)
  if (query.from) search.set('from', query.from)
  if (query.to) search.set('to', query.to)
  if (query.channelId) search.set('channelId', query.channelId)

  return apiRequest(
    `/workspaces/${workspaceId}/reports/funnel?${search.toString()}`,
    funnelReportSchema,
  )
}
